<template>
  <div class="main-content file-log" id="panel">
      <div class="header bg-primary pb-6">
          <div class="container-fluid">
          <div class="header-body">
              <div class="row align-items-center py-4">
                  <div class="col-lg-8 col-6">
                  <h2>Customer Emails</h2>
                  </div>
                  <div class="col-lg-4 col-6 text-right bid">
                  <!-- <button  type="button" class="btn btn-success"><i class="fas fa-user-plus"></i> ADD NEW CUSTOMER</button>
                  <button type="button" class="btn btn-info"><i class="fas fa-file"></i> IMPORT DATA</button> -->
                  <!-- <button type="button" @click="exportToExcel()" class="btn btn-warning rounded ml-1"> <i class="fas fa-download"></i> EXPORT</button> -->
                  <form @submit.prevent="" class="form-inline d-flex justify-content-center md-form form-sm mt-0">
                      <i @click="searchLog()"  class="fas fa-search active cursor-pointer" aria-hidden="true"></i>
                      <input v-on:keyup.enter="searchLog" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)" class="form-control form-control-sm ml-3 w-75" type="text" placeholder="Search" aria-label="Search">
                      <i v-if="searchValue" @click="clearSearch()" class="fas fa-times-circle cursor-pointer"></i>
                  </form>              
                  </div>
              </div>
              
          </div>
          </div>
      </div>
       <div class="container-fluid mt--6 filter-show">
          <div class="card w-100 p-2 mb-2  d-inline-block">
              <div class="d-flex justify-content-between">
                  <h5 class="ml-3">Filters</h5>
                  <span class="btn btn-link" @click="showFilters = !showFilters">
                  <i class="fa" v-bind:class="[showFilters ? 'fa-angle-up' : 'fa-angle-down']" ></i> {{showFilters ? 'Hide' : 'Show'}} Filters
                  </span>
              </div>
              <div class="row" v-if="showFilters">
                  <div class="col-lg-12">
                      <form class="row">
                        <div class="col-md-4 col-lg-3 mt-2">
                          <label for="filter">Status</label>
                          <select v-model="selectedStatus" class="form-control" style="height: 40px;" >
                            <option value="">SELECT</option>
                            <option value="OPEN">OPEN</option>
                            <option value="DRAFT">SENT</option>
                          </select> 
                        </div>
                      <!-- <div class="col-md-6 col-lg-3">
                          <label for="filter" class="col-form-label">Date</label>
                          <datepicker v-model="logDate"  name="fromDate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                      </div> -->
                      <div class="col-md-6 col-lg-3 mt-2">
                          <label for="filter" class="">From</label>
                          <datepicker v-model="fromDate"  name="fromDate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                      </div>
                      <div class="col-md-6 col-lg-3 mt-2">
                          <label for="filter" class="">To</label>
                          <datepicker v-model="toDate"  name="toDate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                      </div>
                      <div class="col-md-6 col-lg-3">
                          <button @click="clearFilter()" type="button" class="btn btn-secondary rounded">Clear</button>
                          <button  @click="getEmailHistory()" type="button" class="btn btn-primary rounded">Filter</button>
                      </div>
                      </form>
                  </div>
              </div>
          </div>
      </div>
      <div class="container-fluid" >
          <div class="row">
               <div class="col-xl-12">
                  <div class="card vh-75" id="scroll">
                      <div class="table-responsive">
                      <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                      <table class="table align-items-center table-flush table-hover bidtbl">
                          <thead class="thead-light psticky">
                          <tr>
                            <th 
                                  scope="col" 
                                  class="sort" v-if="isAdmin"
                                  >Trader</th> 
                              <th 
                                  scope="col" 
                                  class="sort"
                                   >Customer</th>
                              <th 
                                  scope="col" 
                                  class="sort"
                                   >Sent At</th>   
                                     <th 
                                  scope="col" 
                                  class="sort"
                                  >Last Opened At</th>   
                              <th 
                                  scope="col" 
                                  class="sort"
                                  >Recipient Email</th>
                                  <th 
                                  scope="col" 
                                  class="sort"
                                  >Subject</th> 
                                  <th 
                                  scope="col" 
                                  class="sort"
                                  >Filter</th>  
                                  <th 
                                  scope="col" 
                                  class="sort"
                                  >Cusips</th> 
                                  <th 
                                  scope="col" 
                                  class="sort"
                                  >Cc Recipient Email</th>  
                                  <!-- <th 
                                  scope="col" 
                                  class="sort"
                                  >Status</th>  
                                   -->
                                 
                                  
                              <th 
                                  scope="col" 
                                  class="sort text-center"
                                  >Email Content</th> 
                                        
                          </tr>
                          </thead>
                          <tbody class="list no-cursor">
                          <tr v-if="logs.length == 0 && !loading">
                              <td><p class="nodata">No data available</p>
                              </td>
                          </tr>
                          <tr v-for="data in logs" :key="data.id">
                              <td v-if="isAdmin">{{data.traderFname}} {{data.traderLname}}</td>
                              <td>{{data.customerFname}} {{data.customerLname}}</td>
                              <td>{{data.sendDate ? moment(data.sendDate).format("MMMM DD YYYY, h:mm:ss a") : ""}}</td>
                              <td>{{data.updatedDate && data.status == 'OPEN' ? moment(data.updatedDate).format("MMMM DD YYYY, h:mm:ss a") : ""}}</td>

                              <td>{{data.emails.toString()}}</td>
                              <td>{{data.subject}}</td>
                              <td class="text-wrap" style="word-break: break-all;" >
                                <span>{{data.filterNames && data.filterNames.length ? data.filterNames.toString() : ""}}</span></td>
                              <td>{{data.cusips.toString()}}</td>
                              <td>{{data.ccEmails.toString()}}</td>
                              <!-- <td>{{data.status == 'DRAFT' ? 'SENT' : data.status}}</td> -->
                              
                              <td class="text-center">
                                <div>
                                    <button @click="viewEmail(data.emailContent)" class="btn btn-warning rounded ml-2 mt-0" type="button">
                                        <i class="fas fa-eye"></i>  VIEW
                                    </button>
                                    </div>
                              </td>
                              
                          </tr>
                          </tbody>
                      </table>
                      <b-pagination
                          class="mt-4"
                          :total-rows="totalRows"
                          v-model="currentPage"
                          :per-page="perPage"
                          @input="getEmailHistory(currentPage)"
                      ></b-pagination>
                      <div class="total-records">
                          <span>Total Records : {{totalRows}}</span>
                      </div>
                      </div>
                  </div>
                  </div>
          </div>
          <div
              class="modal fade"
              id="show-email"
              tabindex="-1"
              role="dialog"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <!-- <h5 class="modal-title">Confirm</h5> -->
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <div v-html="emailContent"></div>
                  </div>
                  
                </div>
              </div>
            </div>
      </div>
  </div>      
</template>
<script>
import config from "@/config";
import authService from "@/authService";
import Datepicker from 'vuejs-datepicker';

export default {
name: "imsCusipComponent",
components : {
  Datepicker
},
data() {
  return {
      accessToken:null,
      loading : false,
      currentPage: 1,
      perPage: 25,
      searchValue : "",
      totalRows : 0,
      sortColumn: "",
      sortOrder: "ASC",
      logs : [],
      logDate : "",
      showFilters : false,
      emailContent: "",
      selectedStatus : "",
      fromDate : "",
      toDate : "",
      isAdmin : false
   
  };
},
methods: {
  searchLog(){
      this.getEmailHistory();  
  },
  clearSearch(){
      this.searchValue = "";
      this.getEmailHistory();  
  },
  clearFilter(){
      // this.status = "OPEN";
      this.selectedStatus = "";
      this.fromDate = "";
      this.toDate = "";
      this.getEmailHistory();
  },
  getEmailHistory(){
    this.loading = true;
    var fDate = this.fromDate ? this.moment(this.fromDate).utc().format("YYYY-MM-DD") : "";
    var tDate = this.toDate ?  this.moment(this.toDate).utc().format("YYYY-MM-DD") : "";
    var traderId = this.isAdmin ? "" : authService.getUser().id;
      const auth = {
          headers: { 'org-token' : authService.getOrgToken() }
      };
      this.$http
      .get(
         config.baseUrlAutoBidder +
          "/offering-feed/email-listall?page=" +
          this.currentPage +
          "&size=" +
          this.perPage +
          "&search=" +
          encodeURIComponent(this.searchValue)+
          "&traderId="+traderId+
          "&sortColumn=id&sortOrder=DESC"+
          "&status="+this.selectedStatus+
          "&fromDate="+fDate+
          "&toDate="+tDate,
          auth
      )
      .then(result => {
        this.totalRows = result.data.pageInfo.totalElements;
        this.logs = result.data.content;
        this.loading = false;
      }).catch(() => this.loading = false);
  },
  viewEmail(content){
    this.emailContent = content;
    window.$('#show-email').modal("show");

  }
 
},
mounted() {
  //this.logDate = this.moment().format("MM-DD-YYYY");
  this.$cognitoAuth.getUserGroup((err, role) => {
        if (err) {
          console.log("accessToken is not found", err);
        } else {
          this.tenantName = role[0].split("-")[0];
          var roleArray = role.map(item => {
            return  item.split("-")[1];
          })
          roleArray.includes('Admin')   ? this.isAdmin  = true : this.isAdmin  = false;
          this.getEmailHistory();


        }
    });
}
};
</script>
<style scoped>
.file-log .dropdown-menu {
  min-width: 7rem;
}
.file-log .dropdown-menu a {
  margin: 0px !important;
}
</style>